export const INITIATIVES_LIST_TITLE = 'List of initiatives';
export const SEARCH_PLACEHOLDER = 'Search agritech initiatives';

export const EXPORTING_PLACEHOLDER = 'Exporting...'

export const FILTER_HEADING = 'Filters'

export const DROPDOWN_SORT_LEFT_LABEL = 'Sort:'

// FOOTER
export const FOOTER_TITLE = 'FOLLOW US ON'
export const FOOTER_LINKS_TOP = 'FAO Organizational Chart'
export const FOOTER_COPYRIGHT = '© FAO'
